import { ColumnType } from 'antd/lib/table/interface';
import { MultipleItemListModel } from 'components/pages/AssetPage/Tabs/TabConsumption/OptionList/resources/models';

export const ColumnsMultipleTagEditorModal = (title: string): ColumnType<MultipleItemListModel>[] => {
  return [
    {
      title,
      key: 'value',
      width: '100%',
      render: ({ label }) => <span>{label}</span>
    },
  ];
};
